import { useDispatch, useSelector } from 'react-redux'

import { clearBanner } from 'redux/actions/ui/actions'
import { ApplicationState } from 'redux/store/models'
import { Snackbar } from './Snackbar'

export function InfoSnackbar() {
  const dispatch = useDispatch()
  const { infoSnackbarOpen, message, title, footer, action, actionLabel, actionRenderer, autoHideDuration } =
    useSelector((state: ApplicationState) => state.snackbars)

  function handleClose() {
    dispatch(clearBanner())
  }

  return (
    <Snackbar
      type="info"
      isOpen={infoSnackbarOpen}
      title={title}
      message={message}
      footer={footer}
      action={action}
      actionLabel={actionLabel}
      actionRenderer={actionRenderer}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
    />
  )
}
